import { useCallback, useSyncExternalStore } from "react";

/**
 * Whether `query` currently matches, tracking changes (e.g. a window resize).
 * Without `matchMedia` (jsdom, very old browsers) it reports a match.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (typeof window === "undefined" || !window.matchMedia) return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    },
    [query],
  );

  const getSnapshot = () =>
    typeof window === "undefined" || !window.matchMedia
      ? true
      : window.matchMedia(query).matches;

  return useSyncExternalStore(subscribe, getSnapshot, () => true);
}
